import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FormattedMessage } from 'react-intl';

import { parkingStatusMessages } from 'src/features/monitoring/utils/messages';
import { useListSystemComponents } from 'src/features/systems/api/systemComponents/useListSystemComponents';
import { ComponentStatusBadgeOptions, ComponentBadgeOptions } from 'src/features/systems/utils/constants';
import {
    GeneralBlock,
    GeneralBlockHead,
    GeneralBlockHeader,
    GeneralBlockSubtitle,
    GeneralBlockTitle,
} from 'src/registry/components/blocks/GeneralBlock';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import {
    SectionBlock,
    SectionBlockHeader,
    SectionBlockHead,
    SectionBlockTitle,
    SectionBlockBody,
    SectionBlockSeparator,
    SectionBlockSubtitle,
} from 'src/registry/components/blocks/SectionBlock';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { Badge } from 'src/registry/ui/Badge';
import { Skeleton } from 'src/registry/ui/Skeleton';
import { ICON_MAP } from 'src/utils/constants';
import TabRow from 'src/registry/components/navigation/TabRow';
import Tab from 'src/registry/components/navigation/Tab';
import { PATH } from 'src/features/navigation/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';

export default function MonitoringDevices() {
    const { parkingId } = useParking();
    const { data, isLoading, isError } = useListSystemComponents({ parkingId, limit: 100 });

    return (
        <>
            <TabRow className='pt-0.5'>
                <Tab end to={`/${PATH.MONITORING}`}>
                    <FormattedMessage {...parkingStatusMessages.gateways} />
                </Tab>
                <Tab end to={`/${PATH.MONITORING}/pay-station`}>
                    <FormattedMessage {...parkingStatusMessages.payStations} />
                </Tab>
                <Tab end to={`/${PATH.MONITORING}/devices`}>
                    <FormattedMessage {...parkingStatusMessages.devices} />
                </Tab>
            </TabRow>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>
                            <FormattedMessage {...parkingStatusMessages.devices} />
                        </SectionBlockTitle>
                        <SectionBlockSubtitle>
                            <FormattedMessage {...parkingStatusMessages.devicesSubtitle} />
                        </SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody className="grid md:grid-cols-2 xl:grid-cols-3">
                    {isError && (
                        <GeneralMessageBlock
                            className="py-12 md:col-span-2 xl:col-span-3"
                            variant="error"
                            icon={ICON_MAP.CIRCLE_EXCLAMATION}
                        />
                    )}
                    {isLoading && Array.from({ length: 10 }).map((_, index) => <Skeleton key={index} className="h-32" />)}
                    {data?.results?.map((device) => {
                        const option = ComponentStatusBadgeOptions[device.status];
                        const icon = ComponentBadgeOptions[device.component]?.icon as IconProp;

                        return (
                            <GeneralBlock key={device.id} className="w-full flex-row items-center justify-between">
                                <GeneralBlockHeader>
                                    <SquareIcon icon={icon} className="shrink-0" />
                                    <GeneralBlockHead>
                                        <GeneralBlockTitle>{device.name}</GeneralBlockTitle>
                                        <GeneralBlockSubtitle>{device.code}</GeneralBlockSubtitle>
                                    </GeneralBlockHead>
                                </GeneralBlockHeader>
                                <Badge theme={option.theme}>
                                    <FormattedMessage {...option.label} />
                                </Badge>
                            </GeneralBlock>
                        );
                    })}
                </SectionBlockBody>
            </SectionBlock>
        </>
    );
}
